export default class ApiEvent extends Event {
  public static LOAD_START:string = 'apiloadstart'
  public static LOAD_END:string = 'apiloadend'
  public static AUTH_EXPIRED:string = 'apiAuthExpired'
  
  public payload:any = {}
}